import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ICONS from "../../../../../assets/Icons";
import StatusContainer from "../../../../../components/_utils/CommonStatus/StatusContainer";
import InfoCard from "../../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import TabsWeapperSection from "../../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import FormatAmount from "../../../../../components/_utils/FormatAmount/FormatAmount";
import RecreatePromptModalPopup from "../../../../../components/_utils/RecreatePromptModalPopup";
import { setHideBreadCrumb } from "../../../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import { GlobalConfiguration } from "../../../../../utils/configurationProvider";
import CommonToast from "../../../../../components/_utils/CommonToast";

const normalizeBaseErrors = (raw) => {
  if (!raw) return [];

  const result = [];

  if (Array.isArray(raw) && typeof raw[0] === "string") {
    raw.forEach((msg) => {
      result.push({ reason: msg });
    });
    return result;
  }

  if (Array.isArray(raw)) {
    raw.forEach((item) => {
      if (Array.isArray(item?.errors)) {
        item.errors.forEach((err) => {
          if (typeof err === "string") {
            result.push({ reason: err });
          } else if (err?.reason) {
            if (Array.isArray(err.reason)) {
              err.reason.forEach((msg) => result.push({ reason: msg }));
            } else if (typeof err.reason === "string") {
              result.push({ reason: err.reason });
            }
          }
        });
      }
    });
  }

  return result;
};

const IntenralMultiApprovalTxnError = () => {
  const { internalTxnMultiApprovalError, internalTxnMultiRejectApprovalError } =
    useSelector((state) => state.internalTxnSingleApproval);

  const [errorPageData, setErrorPageData] = useState([]);
  const [showRecreateModal, setShowRecreateModal] = useState(false);
  const [loadingBox, setLoadingBox] = useState(false);
  const [transactionId, setTransactionId] = useState("");
  const [allTxnBtn, setAllTxnBtn] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  useEffect(() => {
    const storedSelectedApproval = JSON.parse(
      sessionStorage.getItem("selectedData"),
    );

    if (storedSelectedApproval) {
      setErrorPageData(storedSelectedApproval?.selectedSendTransactions);
    } else {
      setErrorPageData([]);
    }
  }, []);

  const rawErrorData = JSON.parse(sessionStorage.getItem("selectedDataError"));

  const normalizedErrors = normalizeBaseErrors(rawErrorData);

  const handleRecreateDeclinedDetails = (id) => {
    setTransactionId(id);
    setAllTxnBtn("");
    setShowRecreateModal(true);
  };

  const handleRecreateDeclinedDetailsAll = (type) => {
    setShowRecreateModal(true);
    setAllTxnBtn(type);
  };

  const closeRecreateDeclineModal = (type) => {
    setShowRecreateModal(false);
  };

  const handleRecreationConfirmation = async (reason) => {
    setLoadingBox(true);

    const ids =
      allTxnBtn === "All-Txn"
        ? errorPageData.map((t) => t.txn_id).filter(Boolean)
        : [transactionId];

    const response = await dispatch(
      internalTxnMultiRejectApprovalError({
        id: ids,
        AccountIdData: reason,
      }),
    );

    if (response?.payload?.status) {
      CommonToast({
        text: "Transaction rejected and sent for recreation.",
        icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });

      navigate(
        "/internal_transaction_dashboard/internal_transaction_multi_approval/multi_approval/declined",
      );
    } else {
      const msg =
        response?.payload?.errors?.base?.[0] || "Something went wrong.";
      CommonToast({
        text: msg,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
    }

    setLoadingBox(false);
    setShowRecreateModal(false);
  };

  const buttonRows = [
    // [
    //   {
    //     btnText: "Send all for recreation",
    //     enabledBgColor: "var(--text-primary)",
    //     enabledTextColor: "var(--negative-bg)",
    //     imgColor: "var(--positive-bg)",
    //     icon: "https://q2pay.in/new_assets/common/detail_page/recreate_white.svg",
    //     handleFunction: () => handleRecreateDeclinedDetailsAll("All-Txn"),
    //     iconToBeAlign: "left",
    //     fullWidthRequired: true,
    //     hoverOption: "dark",
    //   },
    // ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--bg-positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS?.DASHBOARD,
        handleFunction: () => navigate("/internal_transaction_dashboard"),
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "dark",
      },
    ],
  ];
  console.log(normalizedErrors);
  const TransactionList = ({ transactions }) => (
    <>
      {transactions?.map((txn) => (
        <InfoCard
          key={txn?.txn_id}
          bgColor="var(--negative-card)"
          borderColor="var(--negative-bg)"
          hoverable="white"
          onClick={() =>
            navigate(
              `/internal_transaction_dashboard/internal_transaction_view_all/internal_transaction_detail_page/${txn?.txn_id}`,
            )
          }
          rows={[
            {
              leftTitle: txn?.internal_account_name
                ?.toLowerCase()
                .replace(/\b\w/g, (c) => c.toUpperCase()),
              leftSubTitle: "Account name",
              rightText: true,
              rightTitle: (
                <>
                  INR <FormatAmount price={txn?.amount || 0} />
                </>
              ),
              rightSubTitle: "Amount",
              rightTitleTextColor: "var(--text-primary)",
            },
          ]}
        />
      ))}
    </>
  );

  return (
    <>
      {showRecreateModal && (
        <RecreatePromptModalPopup
          loadingBox={loadingBox}
          onConfirmBtnClick={handleRecreationConfirmation}
          onCancelBtnClick={closeRecreateDeclineModal}
        />
      )}

      <StatusContainer
        status="error"
        buttonRows={buttonRows}
        title={
          <>
            Oops!&nbsp;
            {`Transaction ${
              internalTxnMultiApprovalError ? "Approval" : "Rejection"
            } failed`}
          </>
        }
        subtitle={
          (internalTxnMultiApprovalError ? "Approval" : "Rejection") +
          " of the transactions is not possible due to the following errors, their data can be used to recreate new ones."
        }
      >
        <>
          <TabsWeapperSection title="Account details">
            <>
              {normalizedErrors.length >
              GlobalConfiguration?.lengthCheckZero ? (
                normalizedErrors.map((err, i) => (
                  <InfoCard
                    key={i}
                    bgColor="var(--negative-card)"
                    borderColor="var(--negative-bg)"
                    rows={[
                      {
                        leftTitle: err.reason,
                        leftSubTitle: "Error message",
                      },
                    ]}
                  />
                ))
              ) : (
                <InfoCard
                  bgColor="var(--negative-card)"
                  variant="text"
                  label="No transactions found."
                  subLabel="No error details available."
                />
              )}
            </>
          </TabsWeapperSection>

          <TabsWeapperSection title="Transaction Details">
            <TransactionList transactions={errorPageData} />
          </TabsWeapperSection>
        </>
      </StatusContainer>
    </>
  );
};

export default IntenralMultiApprovalTxnError;
